// Draws a 1080x1350 blue Trading Secret share card and shares/downloads it.
const W = 1080, H = 1350;

function loadImg(src) {
  return new Promise((res) => { const i = new Image(); i.onload = () => res(i); i.onerror = () => res(null); i.src = src; });
}

function rr(ctx, x, y, w, h, r) {
  ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
}

function statBox(ctx, x, y, w, label, value) {
  ctx.fillStyle = 'rgba(255,255,255,0.14)'; rr(ctx, x, y, w, 220, 32); ctx.fill();
  ctx.fillStyle = 'rgba(255,255,255,0.8)'; ctx.font = '600 30px "JetBrains Mono", monospace'; ctx.fillText(label, x + 40, y + 66);
  ctx.fillStyle = '#fff'; ctx.font = '800 110px Outfit, sans-serif'; ctx.fillText(String(value), x + 40, y + 180);
}

export async function buildShareCard({ mode, name, current, longest, rank, wins, date }) {
  await document.fonts?.ready;
  const c = document.createElement('canvas'); c.width = W; c.height = H;
  const ctx = c.getContext('2d');
  const g = ctx.createLinearGradient(0, 0, W, H); g.addColorStop(0, '#00b4ff'); g.addColorStop(1, '#005f8f');
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = 'rgba(255,255,255,0.08)'; ctx.lineWidth = 2;
  for (let x = 0; x < W; x += 90) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke(); }
  for (let y = 0; y < H; y += 90) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke(); }

  const logo = await loadImg('/ts-logo.png');
  ctx.fillStyle = '#fff'; rr(ctx, 80, 80, 120, 120, 28); ctx.fill();
  if (logo) ctx.drawImage(logo, 92, 92, 96, 96);
  ctx.fillStyle = '#fff'; ctx.font = '800 48px Outfit, sans-serif'; ctx.fillText('Trading Secret', 230, 138);
  ctx.fillStyle = 'rgba(255,255,255,0.75)'; ctx.font = '600 26px "JetBrains Mono", monospace'; ctx.fillText('DAILY QUIZ · ' + date, 230, 180);

  ctx.fillStyle = 'rgba(255,255,255,0.85)'; ctx.font = '600 40px "IBM Plex Sans", sans-serif'; ctx.fillText(name, 80, 330, W - 160);
  ctx.fillStyle = '#fff'; ctx.font = '800 92px Outfit, sans-serif';
  if (mode === 'rank') {
    ctx.fillText('Rank #' + rank, 80, 440); ctx.fillText('minggu ini 🏆', 80, 540);
  } else if (mode === 'milestone') {
    ctx.fillText(current + '-Day', 80, 440); ctx.fillText('Milestone 🔥', 80, 540);
  } else {
    ctx.fillText(current + ' hari', 80, 440); ctx.fillText('streak 🔥', 80, 540);
  }

  const bw = (W - 160 - 40) / 2;
  if (mode === 'rank') { statBox(ctx, 80, 640, bw, 'WINS MINGGU INI', wins); statBox(ctx, 120 + bw, 640, bw, 'STREAK', current); }
  else { statBox(ctx, 80, 640, bw, 'CURRENT STREAK', current); statBox(ctx, 120 + bw, 640, bw, 'LONGEST', longest); }

  ctx.fillStyle = 'rgba(255,255,255,0.9)'; ctx.font = '600 38px "IBM Plex Sans", sans-serif';
  ctx.fillText('Boleh kalahkan aku? Jawab soalan', 80, 1010); ctx.fillText('trading setiap hari di Trading Secret.', 80, 1062);
  ctx.fillStyle = '#fff'; rr(ctx, 80, 1150, W - 160, 110, 55); ctx.fill();
  ctx.fillStyle = '#0077b6'; ctx.font = '800 40px Outfit, sans-serif'; ctx.textAlign = 'center';
  ctx.fillText(window.location.host, W / 2, 1220, W - 260); ctx.textAlign = 'left';
  return new Promise((res) => c.toBlob(res, 'image/png'));
}

export async function shareCard(opts) {
  const blob = await buildShareCard(opts);
  const text = opts.mode === 'rank'
    ? `Aku Rank #${opts.rank} Daily Quiz Trading Secret minggu ini 🏆 ${window.location.origin}`
    : opts.mode === 'milestone'
      ? `Aku capai milestone ${opts.current} hari streak Daily Quiz Trading Secret 🔥 ${window.location.origin}`
      : `Streak Daily Quiz aku ${opts.current} hari 🔥 Jom lawan di Trading Secret! ${window.location.origin}`;
  const file = new File([blob], 'trading-secret-quiz.png', { type: 'image/png' });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], text }); return { shared: true }; }
    catch (e) { if (e.name === 'AbortError') return { shared: false }; }
  }
  const url = URL.createObjectURL(blob);
  return { shared: false, url, text };
}
